import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const GraduateCTA: React.FC = () => (
  <Button asChild variant="default" size="sm">
    <Link to="/account/graduate">Graduate</Link>
  </Button>
);
